<template>
    <div class="row">
        <label :class="title_width" :for="name">
            <strong class="float-lg-right float-md-left">{{title}} {{ required ? '*' : ''}}</strong>
        </label>

        <div v-if="!disabled" :class="input_width">
            <span class="form-text m-b-none text-success">
                    {{ note }}
            </span>
            <!--            <vue-editor-->
            <!--                    :name="name"-->
            <!--                    v-model="content"-->
            <!--                    :disabled="disabled"-->
            <!--                    :readonly="readonly"-->
            <!--                    class=""-->
            <!--                    @input="_return"-->
            <!--            >-->

            <!--                <span-->
            <!--                        class="input-group-addon"-->
            <!--                        data-toggle="tooltip"-->
            <!--                        data-placement="right"-->
            <!--                        :title="explanation"-->
            <!--                >-->
            <!--                    <i class="fa fa-info" aria-hidden="true"></i>-->
            <!--                </span>-->
            <!--            </vue-editor>-->
            <editor
                    api-key="2g6ogy3ilhqxedtkqz3klm4c9fwne9whcymyl155ezmrbsmh"
                    :name="name"
                    :disabled="disabled || readonly"
                    :readonly="readonly"
                    v-model="content"
                    @input="_return"
                    :init="{
                        height: 500,
                        menubar: true,
                        plugins: [
                                    'advlist autolink lists link image charmap',
                                    'searchreplace visualblocks code fullscreen',
                                    'print preview anchor insertdatetime media',
                                    'paste code help wordcount table'
                                ],
                        file_picker_types: 'image',
                        automatic_uploads: false,
                        paste_data_images: true,
                        images_upload_handler: function(blobInfo, success, failure, progress){
                            success('data:' + blobInfo.blob().type +';base64,' + blobInfo.base64());
                        },
                        toolbar: 'undo redo ' +
                                '| removeformat ' +
                                '| formatselect fontselect fontsizeselect forecolor backcolor ' +
                                '| bold italic underline ' +
                                '| alignleft aligncenter alignright alignjustify ' +
                                '| bullist numlist outdent indent ' +
                                '| help'
                    }"
            >
            </editor>
            <span class="form-text m-b-none text-danger">
                <div class="row">
                    <div class="col-md-6">
                    {{ error }}
                    </div>
                    <!--                <div class="col-md-6">-->
                    <!--                    <button class="btn float-right" style="margin-left: 2px; margin-right: 2px">123</button>-->
                    <!--                </div>-->
                </div>
            </span>
        </div>

        <div v-else :class="input_width">
            <div class="col-lg-12">
                <div
                        class=""
                        style=" min-height: 30px; width: 100%"
                        v-html="content"
                >
                </div>
            </div>
        </div>

    </div>
</template>

<script>
// import { VueEditor } from "vue2-editor";
// import "vue2-editor/dist/vue2-editor.css";
// import 'quill/dist/quill.core.css';
// import 'quill/dist/quill.bubble.css';
// import 'quill/dist/quill.snow.css';
import Editor from '@tinymce/tinymce-vue'

export default {
    name: "EditorComponent",
    components: {
        // VueEditor,
        //Quill,
        editor: Editor
    },
    props: [
        'name',
        'value',
        'title',
        'error',
        'note',
        'explanation',
        'placeholder',
        'required',
        'readonly',
        'disabled',
        'config'
    ],
    data(){
        return {
            content: '',
            title_width: ('col-form-label col-lg-' + ( this.config.title_width ? this.config.title_width : '4' ) ),
            input_width: ('col-lg-' + ( this.config.input_width ? this.config.input_width : '8' ) )
        }
    },
    methods:{
        _return(){
            this.$emit('onInput',this.name, this.content);
        }
    },
    mounted() {
        this.content = this.value;
        this._return()
    },
    watch: {
        value() {
            this.content = this.value;
        },
    }
}
</script>

<style scoped>

</style>